import React, { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import translations from "../../../../utils/language/translations.json";
import Button from "../../../../iconosv0/src/components/Button/Button.jsx";
import "./../stylesloin.scss";

const ElementRegister = ({ setActiveView  }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => (translations?.Register?.[key]?.[currentLang] ?? key);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [showPwd2, setShowPwd2] = useState(false);
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const validateEmail = (val) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(String(val).toLowerCase());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!validateEmail(email)) {
      setMessage(t("invalidEmailError"));
      return;
    }
    if (password !== confirmPassword) {
      setMessage(t("passwordMismatchError"));
      return;
    }

    try {
      setSubmitting(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/Insertusers`,
        { email, username, password, confirmPassword },
        { withCredentials: true }
      );
      setMessage(res?.data?.message || "OK");
      // After success, go back to login
      navigate(i18n.language === 'fr' ? '/fr/login' : '/login');
    } catch (err) {
      const apiMsg = err?.response?.data?.message;
      setMessage(apiMsg || t("registerError"));
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  const gotoLogin = () => {
  navigate(i18n.language === 'fr' ? '/fr/login' : '/login');
  };


 const eyeOpenIcon = () => {
      return (
 
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            fill="none"
            stroke="#fcfcfc"
            viewBox="0 0 24 24"
          >
            <g
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            >
              <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>{" "}
              <path d="M12.001 5C7.524 5 3.733 7.943 2.46 12c1.274 4.057 5.065 7 9.542 7 4.478 0 8.268-2.943 9.542-7-1.274-4.057-5.064-7-9.542-7z"></path>
            </g>
          </svg>

      );
    };
    const eyeClosedIcon = () => {
      return (
      
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="#ffffff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M2.999 3l18 18M9.843 9.914a3 3 0 004.265 4.22M6.5 6.646A10.024 10.024 0 002.457 12c1.274 4.057 5.065 7 9.542 7 1.99 0 3.842-.58 5.4-1.582m-6.4-12.369c.329-.032.663-.049 1-.049 4.478 0 8.268 2.943 9.542 7a9.954 9.954 0 01-1.189 2.5"
            ></path>
          </svg>
     
      );
    };

  return (
    <main className="auth auth--register">
      <span aria-hidden className="page-bottom-glow" />

      <section className="container auth__container">
        <header className="auth__header">
          <h1>{t("title") || "Create your account"}</h1>
          <p>{t("subtitle") || "One account for collection, trades and sales."}</p>
        </header>

        <form className="auth__card" onSubmit={handleSubmit} noValidate>
          <div className="field">
            <label htmlFor="email">{t("emailLabel")}</label>
            <input
              id="email"
              type="email"
              placeholder={t("emailPlaceholder")}
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="field">
            <label htmlFor="username">{t("usernameLabel")}</label>
            <input
              id="username"
              type="text"
              placeholder={t("usernamePlaceholder")}
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="field">
            <label htmlFor="password">{t("passwordLabel")}</label>
            <div className="password-wrap">
              <input
                id="password"
                type={showPwd ? "text" : "password"}
                placeholder={t("passwordPlaceholder")}
                autoComplete="new-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="toggle-pwd"
                aria-label={showPwd ? t("hidePassword") || "Hide password" : t("showPassword") || "Show password"}
                aria-pressed={showPwd}
                onClick={() => setShowPwd((v) => !v)}
              >
                {showPwd ? eyeClosedIcon() : eyeOpenIcon()}
              </button>
            </div>
          </div>

          <div className="field">
            <label htmlFor="confirmPassword">{t("confirmPasswordLabel")}</label>
            <div className="password-wrap">
              <input
                id="confirmPassword"
                type={showPwd2 ? "text" : "password"}
                placeholder={t("confirmPasswordPlaceholder")}
                autoComplete="new-password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button
                type="button"
                className="toggle-pwd"
                aria-label={showPwd2 ? t("hidePassword") || "Hide password" : t("showPassword") || "Show password"}
                aria-pressed={showPwd2}
                onClick={() => setShowPwd2((v) => !v)}
              >
                {showPwd2 ? eyeClosedIcon() : eyeOpenIcon()}
              </button>
            </div>
          </div>

          <p className="auth__terms">
            <a href="/terms">{t("termsMessage")}</a>
          </p>

     <button
  type="submit"
  className="btn-primary w-full"
  disabled={submitting}
>
  {t("registerButton")}
</button>

          {message ? <p className="auth__message">{message}</p> : null}
        </form>

        <p className="auth__switch">
          {t("haveAccount") || "Already have an account?"}{" "}
          <a href="/login" onClick={gotoLogin}>
            {t("loginCta") || "Sign in"}
          </a>
        </p>
      </section>
    </main>
  );
};

export default ElementRegister;
